import script from "./ModalListaOrganizavel.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalListaOrganizavel.vue?vue&type=script&setup=true&lang=js"

import "./ModalListaOrganizavel.vue?vue&type=style&index=0&id=d5562c96&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5562c96"]])

export default __exports__